export default function Vault() {
    const overlay = document.getElementById("pw-overlay");
    if (!overlay || !overlay.dataset || overlay.dataset.vault !== "1") return;

    const slug = overlay.dataset.slug || "";
    const correct = overlay.dataset.password || "";
    const key = `pw-unlocked:${ slug }`;
    const token = correct;

    const form = document.getElementById("pw-form");
    const input = document.getElementById("pw-input");
    const err = document.getElementById("pw-error");

    function unlock() {
        try {
            localStorage.setItem(key, token);
        } catch (e) {
        }
        document.documentElement.classList.add("pw-unlocked");
        document.documentElement.classList.remove("pw-locked");
        if (document.body) document.body.classList.remove("pw-locked");
        overlay.setAttribute("hidden", "hidden");
    }

    function lock() {
        document.documentElement.classList.remove("pw-unlocked");
        document.documentElement.classList.add("pw-locked");
        if (document.body) document.body.classList.add("pw-locked");
        overlay.removeAttribute("hidden");
    }

    // If already unlocked, hide overlay quickly
    try {
        if (localStorage.getItem(key) === token) {
            unlock();
            return;
        }
    } catch (e) {
    }

    lock();

    if (form) {
        form.addEventListener("submit", function (ev) {
            ev.preventDefault();
            if ((input && input.value) === correct) {
                if (err) err.hidden = true;
                unlock();
            } else {
                if (err) err.hidden = false;
                if (input) {
                    input.focus();
                    input.select();
                }
            }
        });
    }

    if (input) {
        input.addEventListener("input", function () {
            if (err && !err.hidden) err.hidden = true;
        });
        // Focus input initially
        setTimeout(function () {
            if (input) input.focus();
        }, 0);
    }
}
